import React from 'react'

import { useCompareProperty } from '@adUtilities/components/compare-property/utils'
import { PropertyType } from '@adUtilities/types'

import ComparablePropertyItem from './comparable-property-item'

interface ComparePropertyProps {
  comparePropertyProps: ReturnType<typeof useCompareProperty>
  propertyType: PropertyType
  onSelectPrecinct?: (id: string) => void
}

function CompareProperty({
  comparePropertyProps,
  propertyType,
  onSelectPrecinct,
}: ComparePropertyProps) {
  const { compareModeIsActive, comparableProperties } = comparePropertyProps

  if (!compareModeIsActive) {
    return null
  }

  return (
    <div
      className={`flex gap-[15px] ${propertyType === PropertyType.Lot ? 'h-lot-property-comparison-body' : 'h-unit-property-comparison-body max-h-[890px]'}`}
    >
      {comparableProperties.map((item) => (
        <ComparablePropertyItem
          key={item.index}
          comparableProperty={item}
          comparePropertyProps={comparePropertyProps}
          propertyListType={propertyType}
          onSelectPrecinct={onSelectPrecinct}
        />
      ))}
    </div>
  )
}

export default CompareProperty
